import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import SuperAdminHeader from './SuperAdminHeader'

export default function EditAdmin() {
    const { id } = useParams()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [loading, setLoading] = useState(false)
    const [existingAdmins, setExistingAdmins] = useState([])
    const [existingBranches, setExistingBranches] = useState([])
    const [existingStaffs, setExistingStaffs] = useState([])

    const [formData, setFormData] = useState({
        admin_name:'',
        address:'',
        email:'',
        phone:''
    })
    
    const [errors, setErrors] = useState({
        admin_name:'',
        address:'',
        email:'',
        phone:''
    })

    const fetchAdmin = async() => {
        try{
            const res = await axios.get(`${config.baseurl}get_all_admins/`, {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('All Admins:', res.data)

            if(res.status === 200){
                const selectedAdmin = res.data.data.find(item => String(item.id) === String(id))

                if(selectedAdmin){
                    setFormData({
                        admin_name:selectedAdmin.admin_name || '',
                        address: selectedAdmin.address || '',
                        email: selectedAdmin.email || '',
                        phone: selectedAdmin.phone || ''
                    })
                } else {
                    toast.error('Admin not found')
                    navigate('super_admin/all_admins')
                }
            }
        }catch(error){
            console.error('Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to update Admin'

            toast.error(message)
        }
    }
    useEffect(() => {
        if(id){
            fetchAdmin()
        }
    },[id, token, navigate])

  useEffect(() => {
    const fetchExistingData = async () => {
      try {
        const headers = {
          Authorization: `Token ${token}`
        }

        const [
          adminsResponse,
          branchesResponse,
          staffsResponse
        ] = await Promise.all([
          axios.get(
            `${config.baseurl}get_all_admins/`,
            { headers }
          ),
          axios.get(
            `${config.baseurl}get_all_branches/`,
            { headers }
          ),
          axios.get(
            `${config.baseurl}get_all_staffs/`,
            { headers }
          )
        ])

        // Handle both response formats:
        // 1. { data: [...] }
        // 2. [...]

        const admins = Array.isArray(adminsResponse.data)
          ? adminsResponse.data
          : adminsResponse.data?.data || []

        const branches = Array.isArray(branchesResponse.data)
          ? branchesResponse.data
          : branchesResponse.data?.data || []

        const staffs = Array.isArray(staffsResponse.data)
          ? staffsResponse.data
          : staffsResponse.data?.data || []

        console.log('Admins:', admins)
        console.log('Branches:', branches)
        console.log('Staffs:', staffs)

        setExistingAdmins(admins)
        setExistingBranches(branches)
        setExistingStaffs(staffs)

      } catch (error) {
        console.error(
          'Failed to fetch existing admins/branches/staff:',
          error.response?.data || error
        )
      }
    }

    if (token) {
      fetchExistingData()
    }
  }, [token])

    const handleChange = (e) => {
        const { name, value } = e.target

        let newValue = value

        // ============================================================
        // FORMAT PHONE
        // ============================================================

        if (name === 'phone') {
            newValue = value
                .replace(/\D/g, '')
                .slice(0, 10)
        }

        // ============================================================
        // FORMAT EMAIL
        // ============================================================

        if (name === 'email') {
            newValue = value.replace(/\s/g, '')
        }

        // ============================================================
        // UPDATE FORM DATA
        // ============================================================

        setFormData((prev) => ({
            ...prev,
            [name]: newValue
        }))

        let error = ''

        // ============================================================
        // ADMIN NAME
        // ============================================================

        if (name === 'admin_name') {

            if (!newValue.trim()) {
                error = 'Admin Name is required'
            } else {

                const enteredName = newValue
                    .trim()
                    .toLowerCase()

                // Check other Admins
                const adminExists = existingAdmins.some(
                    (admin) =>
                        String(admin.id) !== String(id) &&
                        String(admin.admin_name || '')
                            .trim()
                            .toLowerCase() === enteredName
                )

                // Check Branches
                const branchExists = existingBranches.some(
                    (branch) =>
                        String(branch.branch_name || '')
                            .trim()
                            .toLowerCase() === enteredName
                )

                // Check Staff
                const staffExists = existingStaffs.some(
                    (staff) => {

                        const firstName = String(
                            staff.first_name || ''
                        ).trim()

                        const lastName = String(
                            staff.last_name || ''
                        ).trim()

                        const staffName = `${firstName} ${lastName}`
                            .trim()
                            .toLowerCase()

                        return staffName === enteredName
                    }
                )

                if (adminExists) {
                    error = 'This name already exists as an Admin'
                } else if (branchExists) {
                    error = 'This name already exists as a Branch'
                } else if (staffExists) {
                    error = 'This name already exists as a Staff'
                }
            }
        }

        // ============================================================
        // ADDRESS
        // ============================================================

        if (name === 'address') {

            if (!newValue.trim()) {
                error = 'Address is required'
            }
        }

        // ============================================================
        // PHONE
        // ============================================================

        if (name === 'phone') {

            if (!newValue) {
                error = 'Phone number is required'
            }

            else if (!/^\d+$/.test(newValue)) {
                error = 'Phone number must contain only digits'
            }

            else if (!/^[6-9]/.test(newValue)) {
                error = 'Phone number must start with 6, 7, 8 or 9'
            }

            else if (newValue.length < 10) {
                error = 'Phone number must contain exactly 10 digits'
            }

            else {

                const phone = newValue.trim()

                // Check other Admins
                const adminPhoneExists = existingAdmins.some(
                    (admin) =>
                        String(admin.id) !== String(id) &&
                        String(admin.phone || '').trim() === phone
                )

                // Check Branches
                const branchPhoneExists = existingBranches.some(
                    (branch) =>
                        String(branch.phone || '').trim() === phone
                )

                // Check Staff
                const staffPhoneExists = existingStaffs.some(
                    (staff) =>
                        String(staff.phone || '').trim() === phone
                )

                if (adminPhoneExists) {
                    error =
                        'This phone number already exists for an Admin'
                }

                else if (branchPhoneExists) {
                    error =
                        'This phone number already exists in a Branch'
                }

                else if (staffPhoneExists) {
                    error =
                        'This phone number already exists for a Staff'
                }
            }
        }

        // ============================================================
        // EMAIL
        // ============================================================

        if (name === 'email') {

            if (!newValue.trim()) {
                error = 'Email is required'
            }

            else {

                const email = newValue
                    .trim()
                    .toLowerCase()

                // ----------------------------------------------------
                // Basic Email Validation
                // ----------------------------------------------------

                if (!email.includes('@')) {
                    error = 'Missing @ symbol'
                }

                else {

                    const parts = email.split('@')

                    // More than one @
                    if (parts.length !== 2) {
                        error =
                            'Email must contain only one @ symbol'
                    }

                    else {

                        const username = parts[0]
                        const domain = parts[1]

                        if (!username) {
                            error =
                                'Username is missing before "@"'
                        }

                        else if (!domain) {
                            error =
                                'Domain name is missing'
                        }

                        else if (!domain.includes('.')) {
                            error =
                                'Missing "dot(.)" after domain name'
                        }

                        else {

                            const allowedDomains = [
                                'gmail.com',
                                'yahoo.com',
                                'hotmail.com',
                                'outlook.com'
                            ]

                            if (
                                !allowedDomains.includes(
                                    domain.toLowerCase()
                                )
                            ) {
                                error =
                                    'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'
                            }

                            else {

                                // ------------------------------------------------
                                // Check other Admins
                                // ------------------------------------------------

                                const adminEmailExists =
                                    existingAdmins.some(
                                        (admin) =>
                                            String(admin.id) !== String(id) &&
                                            String(admin.email || '')
                                                .trim()
                                                .toLowerCase() === email
                                    )

                                // ------------------------------------------------
                                // Check Branches
                                // ------------------------------------------------

                                const branchEmailExists =
                                    existingBranches.some(
                                        (branch) =>
                                            String(branch.email || '')
                                                .trim()
                                                .toLowerCase() === email
                                    )

                                // ------------------------------------------------
                                // Check Staff
                                // ------------------------------------------------

                                const staffEmailExists =
                                    existingStaffs.some(
                                        (staff) =>
                                            String(staff.email || '')
                                                .trim()
                                                .toLowerCase() === email
                                    )

                                if (adminEmailExists) {
                                    error =
                                        'This email already exists for an Admin'
                                }

                                else if (branchEmailExists) {
                                    error =
                                        'This email already exists in a Branch'
                                }

                                else if (staffEmailExists) {
                                    error =
                                        'This email already exists for a Staff'
                                }
                            }
                        }
                    }
                }
            }
        }

        // ============================================================
        // UPDATE ERROR
        // ============================================================

        setErrors((prev) => ({
            ...prev,
            [name]: error
        }))
    }
    
    // Validation
    const validateForm = (data) => {
      const newErrors = {}

      // ============================================================
      // ADMIN NAME
      // ============================================================

      if (!data.admin_name.trim()) {
        newErrors.admin_name = 'Admin Name is required'
      } else {

        const adminName = data.admin_name
          .trim()
          .toLowerCase()

        // Exclude currently edited Admin
        const adminExists = existingAdmins.some(
          (admin) =>
            String(admin.id) !== String(id) &&
            String(admin.admin_name || '')
              .trim()
              .toLowerCase() === adminName
        )

        const branchExists = existingBranches.some(
          (branch) =>
            String(branch.branch_name || '')
              .trim()
              .toLowerCase() === adminName
        )

        const staffExists = existingStaffs.some(
          (staff) => {

            const staffName = `${String(
              staff.first_name || ''
            ).trim()} ${String(
              staff.last_name || ''
            ).trim()}`
              .trim()
              .toLowerCase()

            return staffName === adminName
          }
        )

        if (adminExists) {
          newErrors.admin_name =
            'This name already exists as an Admin'
        } else if (branchExists) {
          newErrors.admin_name =
            'This name already exists as a Branch'
        } else if (staffExists) {
          newErrors.admin_name =
            'This name already exists as a Staff'
        }
      }

      // ============================================================
      // ADDRESS
      // ============================================================

      if (!data.address.trim()) {
        newErrors.address = 'Address is required'
      }

      // ============================================================
      // EMAIL
      // ============================================================

      if (!data.email.trim()) {
        newErrors.email = 'Email is required'
      } else {

        const email = data.email
          .trim()
          .toLowerCase()

        if (!email.includes('@')) {
          newErrors.email = 'Missing @ Symbol'
        } else {

          const parts = email.split('@')

          if (parts.length !== 2) {
            newErrors.email =
              'Email must contain only one @ symbol'
          } else {

            const username = parts[0]
            const domain = parts[1]

            if (!username) {
              newErrors.email =
                'Username is missing before "@"'
            } else if (!domain) {
              newErrors.email =
                'Domain name is missing'
            } else if (!domain.includes('.')) {
              newErrors.email =
                'Missing "dot(.)" after domain name'
            } else {

              const allowedDomains = [
                'gmail.com',
                'yahoo.com',
                'hotmail.com',
                'outlook.com'
              ]

              if (!allowedDomains.includes(domain)) {
                newErrors.email =
                  'Only gmail.com, yahoo.com, hotmail.com and outlook.com are allowed'
              } else {

                // Exclude currently edited Admin
                const adminEmailExists =
                  existingAdmins.some(
                    (admin) =>
                      String(admin.id) !== String(id) &&
                      String(admin.email || '')
                        .trim()
                        .toLowerCase() === email
                  )

                const branchEmailExists =
                  existingBranches.some(
                    (branch) =>
                      String(branch.email || '')
                        .trim()
                        .toLowerCase() === email
                  )

                const staffEmailExists =
                  existingStaffs.some(
                    (staff) =>
                      String(staff.email || '')
                        .trim()
                        .toLowerCase() === email
                  )

                if (adminEmailExists) {
                  newErrors.email =
                    'This email already exists for an Admin'
                } else if (branchEmailExists) {
                  newErrors.email =
                    'This email already exists in a Branch'
                } else if (staffEmailExists) {
                  newErrors.email =
                    'This email already exists for a Staff'
                }
              }
            }
          }
        }
      }

      // ============================================================
      // PHONE
      // ============================================================

      if (!data.phone) {
        newErrors.phone = 'Phone number is required'

      } else if (!/^\d+$/.test(data.phone)) {
        newErrors.phone =
          'Phone number must contain only digits'

      } else if (!/^[6-9]\d{9}$/.test(data.phone)) {
        newErrors.phone =
          'Phone number must start with 6, 7, 8 or 9 and contain exactly 10 digits'

      } else {

        const phone = data.phone.trim()

        // Exclude currently edited Admin
        const adminPhoneExists = existingAdmins.some(
          (admin) =>
            String(admin.id) !== String(id) &&
            String(admin.phone || '').trim() === phone
        )

        const branchPhoneExists = existingBranches.some(
          (branch) =>
            String(branch.phone || '').trim() === phone
        )

        const staffPhoneExists = existingStaffs.some(
          (staff) =>
            String(staff.phone || '').trim() === phone
        )

        if (adminPhoneExists) {
          newErrors.phone =
            'This phone number already exists for an Admin'
        } else if (branchPhoneExists) {
          newErrors.phone =
            'This phone number already exists in a Branch'
        } else if (staffPhoneExists) {
          newErrors.phone =
            'This phone number already exists for a Staff'
        }
      }

      return newErrors
    }

    const handleUpdate = async(e) => {
        e.preventDefault()

        const validateErrors = validateForm(formData)
        setErrors(validateErrors)

        if(Object.keys(validateErrors).length > 0){
          return
        }

        setLoading(true)

        try{

            const payload = {
                admin_name:formData.admin_name.trim(),
                address:formData.address.trim(),
                email:formData.email.trim(),
                phone:formData.phone.trim(),
            }
            console.log('Updating Admin Id:', id)
            console.log('Sending Data:', payload)
 
            const res = await axios.put(`${config.baseurl}update_admin/${id}/`, payload, {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('Sending Data', formData)

            if(res.status === 200){
                toast.success('Admin Updated Successfully')
                navigate('/super_admin/all_admins')
            }else{
                toast.error('Error occured while updting Admin')
            }
        }catch(error){
            console.error('Update Admin Error:',error.response?.data); // show full response in console

            const message =
                error.response?.data?.error?.[0] ||
                error.response?.data?.message ||
                "Error occurred";

            toast.error(message);
        }finally{
            setLoading(false)
        }
    }

    const inputClass ='w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100 placeholder:text-slate-400'

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
        <SuperAdminHeader/>

        <div className='max-w-7xl mx-auto px-6 pt-16 pb-6'>
            <div className='items-center justify-between text-center'>
                <h2 className='text-3xl font-bold mb-1'>Edit Admin</h2>
                <p className='mt-2 text-sm text-slate-500'>
                    Update the admin details below
                </p>
            </div>
        </div>

        <div className='max-w-7xl mx-auto px-6 pb-12 justify-between items-center'>
            <div className='mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg'>
                <div className='border-b border-slate-200 bg-slate-50 px-6 py-5 text-center text-lg'>
                    <h2 className='text-lg font-bold'>Admin Registration Form</h2>
                </div>

                {/* Form */}
                <form onSubmit={handleUpdate} className="p-6 md:p-8">
                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

                        {/* Admin Name */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="admin_name"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Admin Name
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="admin_name"
                                type="text"
                                name="admin_name"
                                placeholder="Enter Admin name"
                                value={formData.admin_name}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.admin_name
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.admin_name && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.admin_name}</p>
                            )}
                        </div>

                        {/* Address */}
                        <div className="md:col-span-2">
                            <label
                                htmlFor="address"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Address
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <textarea
                                id="address"
                                name="address"
                                rows={4}
                                placeholder="Enter complete Admin address"
                                value={formData.address}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.address
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.address && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.address}</p>
                            )}
                        </div>

                        {/* Phone */}
                        <div>
                            <label
                                htmlFor="phone"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Phone Number
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="phone"
                                type="text"
                                name="phone"
                                placeholder="Enter 10-digit phone number"
                                value={formData.phone}
                                onChange={handleChange}
                                maxLength={10}
                                inputMode="numeric"
                                className={`${inputClass} ${errors.phone
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.phone && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.phone}</p>
                            )}
                        </div>

                        {/* Email */}
                        <div>
                            <label
                                htmlFor="email"
                                className="mb-2 block text-sm font-semibold text-slate-700"
                            >
                                Email Address
                                <span className="ml-1 text-red-500">
                                    *
                                </span>
                            </label>

                            <input
                                id="email"
                                type="email"
                                name="email"
                                placeholder="Enter email address"
                                value={formData.email}
                                onChange={handleChange}
                                className={`${inputClass} ${errors.email
                                    ? 'border-red-500 focus:border-red-600'
                                    : ''
                                }`}
                            />

                            {errors.email && (
                                <p className='mt-1.5 text-xs font-medium text-red-500'>{errors.email}</p>
                            )}
                        </div>
                    </div>

                    {/* Form Actions */}
                    <div className="mt-8 flex flex-col-reverse gap-3 border-t border-slate-200 pt-6 sm:flex-row justify-end">
                        <button
                            type="button"
                            disabled={loading}
                            onClick={() => navigate('/super_admin/all_admins')}
                            className="rounded-xl bg-slate-100 px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            disabled={loading}
                            className="rounded-xl bg-[#000435] px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#000326] disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {loading ? 'Updating...' : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  )
}
